import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14 4.084H8.669a.75.75 0 1 1 0-1.5H14a.75.75 0 1 1 0 1.5Zm.75 8.581a.75.75 0 0 0-.75-.75H8.669a.75.75 0 0 0 0 1.5H14a.75.75 0 0 0 .75-.75Zm0-4.665a.75.75 0 0 0-.75-.75H8.669a.75.75 0 1 0 0 1.5H14a.75.75 0 0 0 .75-.75Zm-8-2.333v-2A1.753 1.753 0 0 0 5 1.918H3a1.753 1.753 0 0 0-1.75 1.75v2A1.752 1.752 0 0 0 3 7.417h2a1.752 1.752 0 0 0 1.753-1.75ZM5 3.418a.251.251 0 0 1 .25.25v2a.25.25 0 0 1-.25.25H3a.251.251 0 0 1-.25-.25v-2a.251.251 0 0 1 .25-.25Zm1.75 8.913v-2A1.753 1.753 0 0 0 5 8.582H3a1.753 1.753 0 0 0-1.75 1.75v2A1.752 1.752 0 0 0 3 14.081h2a1.752 1.752 0 0 0 1.753-1.75ZM5 10.082a.251.251 0 0 1 .25.25v2a.25.25 0 0 1-.25.25H3a.251.251 0 0 1-.25-.25v-2a.251.251 0 0 1 .25-.25Z';
const draw24px =
  'M21,5.75H13a.75.75,0,0,1,0-1.5h8a.75.75,0,0,1,0,1.5ZM21.75,19a.75.75,0,0,0-.75-.75H13a.75.75,0,0,0,0,1.5h8A.75.75,0,0,0,21.75,19Zm0-7a.75.75,0,0,0-.75-.75H13a.75.75,0,0,0,0,1.5h8A.75.75,0,0,0,21.75,12Zm-12-4V6A2.752,2.752,0,0,0,7,3.25H5A2.753,2.753,0,0,0,2.25,6V8A2.754,2.754,0,0,0,5,10.75H7A2.753,2.753,0,0,0,9.75,8ZM7,4.75A1.25,1.25,0,0,1,8.25,6V8A1.251,1.251,0,0,1,7,9.25H5A1.252,1.252,0,0,1,3.75,8V6A1.251,1.251,0,0,1,5,4.75ZM9.75,18V16A2.752,2.752,0,0,0,7,13.25H5A2.753,2.753,0,0,0,2.25,16v2A2.754,2.754,0,0,0,5,20.75H7A2.753,2.753,0,0,0,9.75,18ZM7,14.75A1.25,1.25,0,0,1,8.25,16v2A1.251,1.251,0,0,1,7,19.25H5A1.252,1.252,0,0,1,3.75,18V16A1.251,1.251,0,0,1,5,14.75Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LayoutCardListIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'layoutCardList')) as IconWithRender;

LayoutCardListIcon.displayName = 'LayoutCardListIcon';
LayoutCardListIcon.propTypes = Icon.propTypes;
LayoutCardListIcon.renderIcon = (props) => <LayoutCardListIcon {...props} />;
export default LayoutCardListIcon;
